import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const PrecedentTable = ({ precendents }) => {
  return (
    <table className="table">
      <caption style={{ captionSide: "top", paddingBottom: 0 }}>
        {precendents.length} Parameters
      </caption>
      <thead>
        <tr>
          <th>Sequence</th>
          <th>Parameter</th>
          <th>Heading</th>
          <th>Last Updated</th>
          <th>Updated By</th>
        </tr>
      </thead>
      <tbody>
        {precendents.map((parameter) => (
          <tr key={parameter.ID}>
            <td>{parameter.SEQUENCE}</td>
            <td className="text-nowrap">
              <Link to={`/parameters/${parameter.CALCULATED}`}>
                {parameter.CALCULATED}
              </Link>
            </td>
            <td>{parameter.NAME}</td>
            <td>{moment(parameter.LAST_UPDATED_DTS).fromNow()}</td>
            <td>{parameter.LAST_UPDATED_BY}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PrecedentTable;
